import React, { useEffect, useCallback, useState } from 'react'
import cn from 'classnames/bind'
import { useTranslation } from 'react-i18next'

import * as serviceWorkerRegistration from '../../serviceWorkerRegistration'

import styles from './service-worker.module.scss'


const cx = cn.bind(styles)

const ServiceWorker = () => {
  const { t } = useTranslation()

  const [showReload, setShowReload] = useState(false)
  const [waitingWorker, setWaitingWorker] = useState<ServiceWorker | null>(null)

  const handleSWUpdate = useCallback((registration: ServiceWorkerRegistration) => {
    setShowReload(true)
    setWaitingWorker(registration.waiting)
  }, [])

  useEffect(() => {
    serviceWorkerRegistration.register({ onUpdate: handleSWUpdate })
  }, []) // eslint-disable-line

  const reloadPage = useCallback(() => {
    waitingWorker?.postMessage({ type: 'SKIP_WAITING' })
    setShowReload(false)
    document.location.reload()
  }, [waitingWorker])

  return (showReload
    ? <div className={cx(styles.message, { active: true })}>
      <div className={styles['message--text']}>
        {t(
          'template_cafeteria_menu.api_errors.update',
          'Обнаружена новая версия приложения. Обновление произойдет автоматически при следующем посещении сайта или вы можете это сделать сейчас'
        )}
      </div>
      <button
        className={styles['message--button']}
        onClick={reloadPage}
      >
        {t('template_cafeteria_menu.api_errors.bt_reset', 'Обновить')}
      </button>
    </div>
    : null
  )
}

export default ServiceWorker
